/**
 * Step data for the landing page How It Works section.
 *
 * Each entry maps to an i18n key prefix under the `landing:howItWorks`
 * namespace (e.g. "step1").
 *
 * @module landing/content/how-it-works
 */

/** Describes a single how-it-works step. */
export interface HowItWorksStep {
  /** Step number displayed in the circle indicator. */
  step: number;
  /** i18n key prefix under `landing:howItWorks` (e.g. "step1"). */
  i18nKey: string;
}

/** Steps displayed on the landing page. */
export const HOW_IT_WORKS_STEPS: HowItWorksStep[] = [
  { step: 1, i18nKey: 'step1' },
  { step: 2, i18nKey: 'step2' },
  { step: 3, i18nKey: 'step3' },
];
